import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-CONSULTATION-TRANSACTIONS-LIST-------------------------------------------------*/
export const getConsultationTransactionsListAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST,
    payload,
  };
};

export const getConsultationTransactionsListSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST_SUCCESS,
    payload,
  };
};

export const getConsultationTransactionsListFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST_FAIL,
    payload,
  };
};
/*---------------------------------------------ANNULATION-TRANSACTION-------------------------------------------------*/
export const annulationTransactionAction = (payload) => {
  return {
    type: ActionsTypes.ANNULATION_TRANSACTION,
    payload,
  };
};

export const annulationTransactionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.ANNULATION_TRANSACTION_SUCCESS,
    payload,
  };
};

export const annulationTransactionFailAction = (payload) => {
  return {
    type: ActionsTypes.ANNULATION_TRANSACTION_FAIL,
    payload,
  };
};

export const annulationTransactionReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.ANNULATION_TRANSACTION_REINITIALIZATION,
    payload,
  };
};
/*------------------------------------------Excel---------------------*/
export const excelExport = (payload) => {
  return {
    type: ActionsTypes.GENERAL_EXCEL_EXPORT,
    payload,
  };
};
export const printSuccess = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_SUCCESS,
    payload,
  };
};
export const printFail = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_FAIL,
    payload,
  };
};
export const printReinitialization = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_REINITIALIZATION,
    payload,
  };
};